/** Portal-relative path for a cabinet user profile (matches UsersApp.handleEditUser). */
export const buildUserProfilePath = (userId: number, currentUserId: number): string => {
  if (userId === currentUserId) {
    return '/profile';
  }

  const params = new URLSearchParams({
    view: 'edit',
    userId: String(userId),
  });
  return `/users?${params.toString()}`;
};

export const buildUserProfileHref = (
  portalPath: string,
  userId: number,
  currentUserId: number,
): string => `${portalPath}${buildUserProfilePath(userId, currentUserId)}`;
